import { geocodeAddresses } from '../DromoUploader/Geocoder'
import {
  IRowToAdd,
  IRowHookInput,
  IRowHookOutputInternal,
} from 'dromo-uploader-js/dist/interfaces'
import { AxiosInstance } from 'axios'
import { repairFailedGeocodes } from '../DromoUploader/repairFailedGeocodes'
import { getSitesNeedingSiteActions } from '../DromoUploader/getSitesNeedingSiteActions'
import { generateSiteActions } from './generateSiteActions'
import {
  existingRecordSiteActionOptions,
  uploadMatchedRecordSiteActionOptions,
  uploadUnmatchedRecordSiteActionOptions,
} from '../DromoUploader/commonFieldSchemas'

export async function handleBulkProcessing({
  records,
  isUpdate,
  api,
  reitId,
}: {
  records: IRowHookInput[]
  isUpdate: boolean
  api: AxiosInstance
  reitId: number
}): Promise<{
  missingDataRows: (IRowToAdd & { rowId: string })[]
  updatedRows: IRowHookOutputInternal[]
}> {
  // geocode sites first
  const geocodedSites = await geocodeAddresses(records, isUpdate, api)

  const { sitesNeedingSiteActions, sitesToSkip } = getSitesNeedingSiteActions(
    isUpdate,
    geocodedSites
  )

  // generate site actions
  const {
    updatedRows: updatedRowsFromGenerateSiteActions,
    missingDataRows,
    siteActionResponse,
  } = await generateSiteActions({
    records: sitesNeedingSiteActions,
    isUpdate,
    reitId,
    api,
  })

  let updatedRows = updatedRowsFromGenerateSiteActions

  // On the initial run of the bulk row hook,
  // try to fill in addresses for sites that failed geocoding if they match existing records.
  if (!isUpdate) {
    updatedRows = repairFailedGeocodes(updatedRows, siteActionResponse)
  }
  updatedRows = updatedRows.concat(sitesToSkip)

  if (isUpdate) {
    // On user update, set the possible Site Action options based on whether 'Sold' is checked and whether an existing record match was found
    updatedRows = setSiteActionOptions(updatedRows)
  }

  return { missingDataRows, updatedRows }
}

function setSiteActionOptions(
  records: IRowHookOutputInternal[]
): IRowHookOutputInternal[] {
  return records.map((record) => {
    if (record.row.sold?.value === 'checked') {
      record.row.siteAction.selectOptions = existingRecordSiteActionOptions
    } else if (record.row.existingRecordId.value) {
      record.row.siteAction.selectOptions = uploadMatchedRecordSiteActionOptions
    } else {
      record.row.siteAction.selectOptions =
        uploadUnmatchedRecordSiteActionOptions
    }
    return record
  })
}
